import { render, staticRenderFns } from "./EventResponsesDataTable.vue?vue&type=template&id=5d9077bc"
import script from "./EventResponsesDataTable.vue?vue&type=script&lang=js"
export * from "./EventResponsesDataTable.vue?vue&type=script&lang=js"
import style0 from "./EventResponsesDataTable.vue?vue&type=style&index=0&id=5d9077bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports